import React from 'react'
import { Logo, LogoProps } from '@deal/components'

const LogoContainer: React.FC<LogoProps> = props => <Logo brand="curated" {...props} />

export default LogoContainer
